import React from 'react';

import EventRounded from '@mui/icons-material/EventRounded';
import { Badge } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';

import {
  BaseColorKeys, NotifierColorKeys, SubjectColorKeys,
} from '../../theme';

import {
  Date,
  DateStack,
  EventIconWrapper,
  Month,
} from './index.styles';

interface DateIconProps {
  date?: Dayjs;
  color?: BaseColorKeys | SubjectColorKeys | NotifierColorKeys;
}

const DateIcon = ({ date, color }: DateIconProps) => (
  <DateStack direction="column" alignItems="center">
    <Month
      variant="body1"
      fontSize={12}
      $color={color}
    >
      {date?.format('MMM').toUpperCase()}
    </Month>
    <Date
      variant="body1"
      fontSize={22}
      $color={color}
    >
      {date?.format('DD')}
    </Date>
  </DateStack>
);

const VariableIcon = ({ date, color }: DateIconProps) => {
  if (date) {
    return (
      <DateIcon date={date} color={color} />
    );
  }
  return (
    <EventIconWrapper $color={color}>
      <EventRounded fontSize="large" />
    </EventIconWrapper>
  );
};

interface EventIconProps {
  date?: Dayjs;
  color?: BaseColorKeys | SubjectColorKeys | NotifierColorKeys;
  activeStartDate?: Dayjs;
  activeEndDate?: Dayjs;
}

const EventIcon = ({ date, color, activeStartDate, activeEndDate }: EventIconProps) => (
  <Badge
    color="success"
    variant="dot"
    badgeContent={dayjs().isBetween(activeStartDate, activeEndDate) ? undefined : 0}
  >
    <VariableIcon
      date={date}
      color={color}
    />
  </Badge>
);

export default EventIcon;
